import { autoinject } from "aurelia-framework";
import { Zone } from "../../../models/zone";

@autoinject
export class StructureZone {
	zone: Zone;

	bind(bindingContext: any, overrideContext: any) {
		this.zone = bindingContext.zone;
	}
}
